<template>
  <div>
    <!--Header-->
    <div class="header bg-home pt-5">
      <div class="container">
        <div class="header-body">
          <div class="row align-items-center">
            <div class="col-lg-6">
              <div class="mt-6 mb-6">
                <i class="fas fa-check-circle"></i>
                <h1 class="display-1 text-white font-weight-bold mb-0">Finalizado!</h1>
<!--                <h2 class="display-4 text-white font-weight-light">A beautiful premium dashboard for Bootstrap 4.</h2>-->
                <p class="lead text-white mt-4">Para ver o resultado é só seguir os últimos passos abaixo.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 860 100" preserveAspectRatio="none" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-default" points="860 0 860 100 0 100"></polygon>
        </svg>
      </div>

    </div>
    <!-- Page content -->

    <section id="intro-content" class="mt-5">
      <div class="container">

        <validation-observer v-slot="{handleSubmit}" ref="formValidator">
          <form id="final" class="needs-validation qa"
                @submit.prevent="handleSubmit(nextPage)">

            <div class="form-row">

              <div class="col-md-6">
                <base-input @focusout="update()"
                            label="Seu email"
                            name="Email"
                            placeholder="Email"
                            success-message="Tudo certo!"
                            rules="required"
                            type="email"
                            v-model="userContact.email">
                </base-input>
              </div>

              <div class="col-md-6">
                <base-input @focusout="update()"
                            label="Qual seu WhatsApp?"
                            name="Whatsapp"
                            placeholder="(00) 00000-0000"
                            type="tel"
                            success-message="Tudo certo!"
                            v-mask="'(##) ##### ####'"
                            v-model="userContact.whatsapp">
                </base-input>
              </div>
              <div class="col-md-6">
                <base-input label="Como ficou sabendo dessa ferramenta?">
                  <el-select @focusout="update()" v-model="userContact.reference" filterable
                             placeholder="Selecione">
                    <el-option label="Indicação" value="indicação"></el-option>
                    <el-option label="Facebook" value="facebook"></el-option>
                    <el-option label="Instagram" value="instagram"></el-option>
                    <el-option label="YouTube" value="youtube"></el-option>
                    <el-option label="Anúncios" value="ads"></el-option>
                    <el-option label="Outros" value="outros"></el-option>
                  </el-select>
                </base-input>
              </div>

              <div class="question">
                <p class="form-control-label">Você é inscrito no canal do Davi no YouTube?</p>
                <div v-if="feedback.youtube === false" class="question-buttons align-center py-2">
                  <base-button type="secondary" @click="feedback.youtube = true; social.youtube = true">Sim</base-button>
                  <base-button class="btn-neutral" @click="feedback.youtube = true; social.youtube = false">Não</base-button>

                </div>
                <div v-else class="thanks-feedback">
                  <div v-if="social.youtube === true" style="display: flex; margin-bottom: 3rem">
                    <img src="img/theme/db.jpg">
                    <p style="padding-top: 4px">Obrigado!</p>
                  </div>
                  <div v-else style="display: flex; margin-bottom: 4rem">
                    <i class="fas fa-check"></i>
                    <p>Ok</p>
                  </div>
                </div>
              </div>

              <div class="question">
                <p class="form-control-label">Você participa do Telegram do Davi?</p>
                <div v-if="feedback.telegram === false" class="question-buttons align-center py-2">
                  <base-button type="secondary" @click="feedback.telegram = true; social.telegram = true">Sim</base-button>
                  <base-button class="btn-neutral" @click="feedback.telegram = true; social.telegram = false">Não</base-button>

                </div>
                <div v-else class="thanks-feedback">
                  <div v-if="social.telegram === true" style="display: flex; margin-bottom: 3rem">
                    <img src="img/theme/db.jpg">
                    <p style="padding-top: 4px">Obrigado!</p>
                  </div>
                  <div v-else style="display: flex; margin-bottom: 4rem">
                    <i class="fas fa-check"></i>
                    <p>Ok</p>
                  </div>
                </div>
              </div>

              <div class="question">
                <p class="form-control-label">Você já segue o Davi Braga no Instagram?</p>
                <div v-if="feedback.instagram === false" class="question-buttons align-center py-2">
                  <base-button type="secondary" @click="feedback.instagram = true; social.instagram = true; disabled = false">Sim</base-button>
                  <base-button class="btn-neutral" @click="followInstagram()">Não</base-button>
                </div>
                <div v-else class="thanks-feedback">
                  <div v-if="social.instagram === true" style="display: flex; margin-bottom: 3rem">
                    <img src="img/theme/db.jpg">
                    <p style="padding-top: 4px">Obrigado!</p>
                  </div>
                  <div v-else style="display: flex; margin-bottom: 4rem">
                    <i class="fas fa-check"></i>
                    <p>Ok</p>
                  </div>
                </div>
              </div>
              <modal :show.sync="modals.follow">
                <template slot="header">
                  <h5 class="modal-title" id="exampleModalLabel">Importante</h5>
                </template>
                <div>
                  <p>Para ver seu resultado basta seguir<br />o Davi Braga no Instagram</p>
                  <button @click="followButton()" class="follow-button mb-5">
                    <div class="instagram follow-content">
                      <div>
                        <img src="https://instagram.fcgh2-1.fna.fbcdn.net/v/t51.2885-19/s320x320/109777129_1945806042227564_6484999046422719900_n.jpg?_nc_ht=instagram.fcgh2-1.fna.fbcdn.net&_nc_ohc=MWUouURvmGUAX-CgY_b&oh=d956695e9827a07c83a558f1faf3396c&oe=5FAE80A2">
                      </div>
                      <h4>Seguir Davi Braga</h4>
                    </div>
                  </button>
                </div>
                <template slot="footer" v-if="modals.ready === true">
                  <base-button type="secondary" @click="modals.follow = false;feedback.instagram = true; social.instagram = true; disabled = false">Pronto!</base-button>
                </template>

              </modal>

            </div>


            <base-input :rules="{ required: { allowFalse: false } }" name="Política de Privacidade">
                            <base-checkbox v-model="agree">
                              Li e concordo com a Política de Privacidade
                            </base-checkbox>
                          </base-input>

            <div v-if="loading === false" class="align-center">
              <base-button outline type="secondary" class="back-btn" @click="prevPage()">Voltar</base-button>
              <base-button :disabled="disabled" type="secondary" native-type="submit">Ver Resultado</base-button>
            </div>
            <div class="loader-box">
              <propagate-loader :color="loader.color" :loading="loading" :size="loader.size" sizeUnit="px"></propagate-loader>
            </div>
          </form>
        </validation-observer>
      </div>
    </section>

  </div>
</template>
<script>
  import { Tooltip } from 'element-ui';
  import { Select, Option } from 'element-ui';
  import request from "../../plugins/request.js";
  import requestZapier from "../../plugins/requestZapier.js";
  import moment from 'moment';
  import db from "../../plugins/firebase.js"

  export default {
    name: 'home-page',
    data: () => ({
      modals: {
        follow: false,
        ready: false,
      },
      disabled: true,
      loader: {
        size: 10,
        color: '#5bc34d',
      },
      feedback: {
        instagram: false,
        youtube: false,
        telegram: false
      },
      social: {
        instagram: null,
        youtube: null,
        telegram: null
      },
      validated: false,
      loading: false,
      slider: 0,
      valuation: 0,
      userData: {},
      setFirestore: {},
      userContact: {
        whatsapp: '',
        reference: '',
        email: ''
      },
      agree: false
    }),
    methods: {
      followButton () {
        window.open('https://instagram.com/davibraga', '_blank')
        setTimeout(this.showButton, 3000)
      },
      showButton () {
        this.modals.ready = true
      },
      followInstagram (){
        this.modals.follow = true
        this.feedback.instagram = true
        this.social.instagram = false
        console.log(this.modals.follow, this.feedback.instagram, this.social.instagram)
      },
      prevPage () {
        this.$router.push('qa3')
        console.log(this.social, this.feedback)
      },
      update () {
        window.localStorage.setItem("userContact", JSON.stringify(this.userContact))
      },
      async nextPage () {
        await this.setCore()
      },
      setCore () {
        let userData = JSON.parse(window.localStorage.getItem("userData"))
        let p1 = JSON.parse(window.localStorage.getItem("p1"))
        console.log('p1', p1)
        let p2 = JSON.parse(window.localStorage.getItem("p2"))
        console.log('p2', p2)
        let p3 = JSON.parse(window.localStorage.getItem("p3"))
        console.log('p3', p3)
        let p1sum = JSON.parse(window.localStorage.getItem("p1sum"))
        let p2sum = JSON.parse(window.localStorage.getItem("p2sum"))
        let p3sum = JSON.parse(window.localStorage.getItem("p3sum"))
        let answers = {...p1, ...p2, ...p3}
        let result = p1sum + p2sum + p3sum
        console.log('result', result)
        console.log('answers', answers)
        let date = moment().format('L')
        let userContact = this.userContact
        let bodyZapier = {
          answers,
          userContact,
          userData,
          "social": this.social,
          date: date,
        }

        this.sendRequest(result, bodyZapier, userData.gender)
        // this.setFirestore = {
        //   privacy: this.agree,
        //   timestamp: Date.now(),
        //   email: userContact.email,
        //   overview: Object.assign(userData, userContact, {foundationTimestamp: adjutedFounderDate}),
        //
        //   id
        // }
      },
      sendRequest(result, bodyZapier, gender) {
        let id = Date.now().toString().concat("." + Math.floor(Math.random() * 9999))
        this.loading = true
        this.calcResult(result, gender)
        this.requestZapier(bodyZapier, result)
        // this.sendFirestore(this.setFirestore, id)

      },
      goToResult (r, title, text) {
        this.$router.push({
          name: 'result',
          params: {
            result: r,
            title: title,
            text: text,
            email: this.userContact.email,
            telegram: this.social.telegram,
            youtube: this.social.youtube,
          }
        })
      },
      calcResult (r, gender) {
        if (gender === "Feminino") {
          if (r < 16) {
            let text = 'Não se preocupe se você ficou nessa categoria. Durante muito tempo, acreditava-se que ou se nasce empreendedor ou não tem mais jeito. Estudiosos mapearam os comportamentos do cérebro humano e verificaram ser possível, sim, desenvolver atitudes empreendedoras ao longo da vida. Então, com muito empenho e esforço – que, aliás, são características que todo empreendedor precisa ter –, você consegue. Basta realmente querer e agir!'
            let title = 'Empreendedora Iniciante'
            this.goToResult(r, title, text)
          }
          else if (r > 15 && r < 31) {
            let text = 'Você conseguiu um bom resultado. Tem boas habilidades interpessoais, mas pode melhorar e muito. Precisa aprender a liderar equipes e não ter tanto apego às coisas que julga estáveis. Se optar por adotar um estilo de vida empreendedor, precisará estar mais aberta e receptiva às mudanças. E a resiliência precisa fazer parte da sua vida.'
            let title = 'Empreendedora Curiosa'
            this.goToResult(r, title, text)
          }
          else if (r > 30 && r < 46) {
            let text = 'Você ainda pode melhorar e ter um pouco mais de vontade de ser 100% empreendedora. A palavra-chave é autoconfiança. Pense na quantidade de riquezas que pode gerar para a sociedade. E não estou falando só de dinheiro, mas sim de satisfação e crescimento pessoal. O que você quer que o Google fale a seu respeito? Como quer ser lembrada? As respostas a essas perguntas são exatamente o que você precisa lutar para realizar.'
            let title = 'Empreendedora Promissora'
            this.goToResult(r, title, text)
          }
          else {
            let text = 'Você tem todas as habilidades de que uma boa empreendedora precisa. Sua postura é coerente diante das adversidades, sua capacidade de assumir riscos é fenomenal. Das suas características, a mais importante é o espírito questionador, que age como uma engrenagem fazendo com que todas as suas outras qualidades venham à tona e de forma equilibrada. Apesar do seu resultado ter sido excelente, não se esqueça de continuar aprendendo sempre. Busque novos caminhos e inspirações. Não se permita viver à sombra de uma boa ideia que teve no passado ou ancorado em sucessos que já conquistou. Procure sempre o novo, o diferente, o desafio, para continuar a crescer. E sempre lembre que estabilidade não existe!'
            let title = 'Empreendedora Nata'
            this.goToResult(r, title, text)
          }
        } else {
          if (r < 16) {
            let text = 'Não se preocupe se você ficou nessa categoria. Durante muito tempo, acreditava-se que ou se nasce empreendedor ou não tem mais jeito. Estudiosos mapearam os comportamentos do cérebro humano e verificaram ser possível, sim, desenvolver atitudes empreendedoras ao longo da vida. Então, com muito empenho e esforço – que, aliás, são características que todo empreendedor precisa ter –, você consegue. Basta realmente querer e agir!'
            let title = 'Empreendedor Iniciante'
            this.goToResult(r, title, text)
          } else if (r > 15 && r < 31) {
            let text = 'Você conseguiu um bom resultado. Tem boas habilidades interpessoais, mas pode melhorar e muito. Precisa aprender a liderar equipes e não ter tanto apego às coisas que julga estáveis. Se optar por adotar um estilo de vida empreendedor, precisará estar mais aberto e receptivo às mudanças. E a resiliência precisa fazer parte da sua vida.'
            let title = 'Empreendedor Curioso'
            this.goToResult(r, title, text)
          } else if (r > 30 && r < 46) {
            let text = 'Você ainda pode melhorar e ter um pouco mais de vontade de ser 100% empreendedor. A palavra-chave é autoconfiança. Pense na quantidade de riquezas que pode gerar para a sociedade. E não estou falando só de dinheiro, mas sim de satisfação e crescimento pessoal. O que você quer que o Google fale a seu respeito? Como quer ser lembrado? As respostas a essas perguntas é exatamente o que você precisa lutar para realizar.'
            let title = 'Empreendedor Promissor'
            this.goToResult(r, title, text)
          } else {
            let text = 'Você tem todas as habilidades de que um bom empreendedor precisa. Sua postura é coerente diante das adversidades, sua capacidade de assumir riscos é fenomenal. Das suas características, a mais importante é o espírito questionador, que age como uma engrenagem fazendo com que todas as suas outras qualidades venham à tona e de forma equilibrada. Apesar do seu resultado ter sido excelente, não se esqueça de continuar aprendendo sempre. Busque novos caminhos e inspirações. Não se permita viver à sombra de uma boa ideia que teve no passado ou ancorado em sucessos que já conquistou. Procure sempre o novo, o diferente, o desafio, para continuar a crescer. E sempre lembre que estabilidade não existe !'
            let title = 'Empreendedor Nato'
            this.goToResult(r, title, text)
          }
        }
      },
      requestZapier (body, result) {
        requestZapier('https://hooks.zapier.com/hooks/catch/8448952/oge3jy0/', 'POST',{body, result})
      },
      // sendFirestore (body, id) {
      //   db.collection('valuation').doc(id).set(body)
      // }

    },
    components: {
      [Tooltip.name]: Tooltip,
      [Select.name]: Select,
      [Option.name]: Option,
    },
    created() {
      let userContactPayload = window.localStorage.getItem("userContact")

      if (userContactPayload != null) {
        this.userContact = JSON.parse(userContactPayload)
      }
    }
  };
</script>
